var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-layout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('JsonEditor',{attrs:{"options":{
                confirmText: 'confirm',
                cancelText: 'cancel',
            },"obj-data":_vm.JsonMenu},model:{value:(_vm.JsonMenu),callback:function ($$v) {_vm.JsonMenu=$$v},expression:"JsonMenu"}}),_c('custom-button',{attrs:{"default":""},on:{"on-btn-click":_vm.submit}},[_vm._v(" Save ")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }